import React, { createContext, useContext } from 'react';
import { Outlet } from 'react-router-dom';

const IsDateSectionContext = createContext();

export function useIsDateSection() {
    return useContext(IsDateSectionContext);
}

export default function IsDateSectionProvider() {
    return (
        <IsDateSectionContext.Provider value={true}>
            <Outlet />
        </IsDateSectionContext.Provider>
    );
}
